import Button from "@shared/v2/Button";
import TextButton from "@shared/v2/TextButton";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import ZoomCard from "./shared/ZoomCard";
import { useIsPlace } from "../reducers/layoutReducer/selectors";

const BrivityLeadsCard = () => {
  const isPlace = useIsPlace();
  const openLearnMore = () => {
    window.open(
      isPlace
        ? "https://www.brivity.com/real-estate-leads?utm_campaign=AO-Product-AddOns-PLACE&utm_source=in-app&utm_medium=organic&utm_term=learn-more&utm_content=PLACE-BrivityLeads-button"
        : "https://www.brivity.com/real-estate-leads?utm_campaign=AO-Product-AddOns-BP&utm_source=in-app&utm_medium=organic&utm_term=get-more-leads&utm_content=BP-BrivityLeads-button",
      "_blank",
    );
  };
  return (
    <ZoomCard
      actions={
        <>
          <Button
            size="medium"
            schema="secondary"
            className={`tw-flex tw-items-center tw-gap-[4px] ${isPlace ? "" : "hs-cta-trigger-button hs-cta-trigger-button-190807761672"}`}
            onClick={() => {
              if (isPlace) {
                window.open(
                  "https://meetings.hubspot.com/amy-gerrish/place-leads-consult?uuid=33c2d99e-dca8-40ec-adf2-8da95f5350c4",
                  "_blank",
                );
              }
            }}
          >
            Get More Leads <ArrowUpRightFromSquareSolidV6 />
          </Button>

          <TextButton
            className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]"
            size="medium"
            onClick={openLearnMore}
          >
            Learn More <ArrowUpRightFromSquareSolidV6 />
          </TextButton>
        </>
      }
      onClick={openLearnMore}
      title="Brivity Leads"
      description="Make it easier to connect with your leads, gain insight into your marketing campaigns, and understand your ROI like never before."
      imgSrc="/images/bg-card-brivity-leads.png"
      imgClassName="tw-mr-[-12px]"
    />
  );
};

export default BrivityLeadsCard;
